module.exports = {
  "1": "en",
  "2": "es",
  "3": "pt",
  "4": "ru",
  "5": "fr",
  "6": "de",
  "7": "zh-cn",
  "8": "zh-tw",
  "9": "ja"
};
